import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const IconArrowCollapseRight = memo(
  forwardRef((props, ref) => (
    <SvgIcon {...props} ref={ref} viewBox="0 0 24 24">
      <path
        d="M4.875 11.3438H12.925L9.6875 8.10625C9.425 7.84375 9.425 7.45 9.6875 7.1875C9.95 6.925 10.3438 6.925 10.6063 7.1875L14.9812 11.5625C15.2438 11.825 15.2438 12.2188 14.9812 12.4813L10.6063 16.8562C10.475 16.9875 10.3 17.0312 10.125 17.0312C9.95 17.0312 9.775 16.9875 9.64375 16.8562C9.38125 16.5938 9.38125 16.2 9.64375 15.9375L12.8812 12.7H4.875C4.525 12.7 4.21875 12.3938 4.21875 12.0438C4.21875 11.6938 4.525 11.3438 4.875 11.3438ZM16.25 6.53125C16.25 6.18125 16.5562 5.875 16.9062 5.875C17.2563 5.875 17.5625 6.18125 17.5625 6.53125V17.4688C17.5625 17.8188 17.2563 18.125 16.9062 18.125C16.5562 18.125 16.25 17.8188 16.25 17.4688V6.53125Z"
        fill="currentColor"
      />
    </SvgIcon>
  ))
);
